import { IFormValues } from './interfases';

export const DEFAULT_VALUES: IFormValues = {
  first_name: '',
  nickname: '',
  dob: '',
  phone: '',
  email: '',
};
